@if (isEnabled() && webchatColor()) {
  <div
    [ngClass]="{
      'chat-box-container-full': fullView() && !embedded(),
      'chat-box-container-mini': !fullView() && !embedded(),
      'chat-box-container-full--embedded': embedded(),
    }"
  >
    @if (showWebchat()) {
      <webchat-box
        (clickedClose)="closeChat()"
        (clickedHeader)="expandChat()"
        (sentMessage)="sendMessage($event)"
        (setPreferredBooking)="setPreferredBooking($event)"
        [currentParticipantId]="currentParticipantId()"
        [isReplying]="isReplying()"
        [welcomeMessage]="welcomeMessage()"
        [assistantName]="
          isDefaultAssistantName()
            ? ('WEBCHAT.WIDGET.DEFAULT_ASSISTANT_NAME' | translate)
            : this.configSvc.config()?.assistantName
        "
        [assistantAvatarUrl]="assistantAvatarUrl()"
        [messageGroups]="messageGroups()"
        [messages]="messages()"
        [fullView]="fullView()"
        [embedded]="embedded()"
        [position]="position()"
        [absolutePosition]="false"
        [webchatColor]="webchatColor()"
        [webchatTextColor]="webchatTextColor()"
        [webchatAccentColor]="webchatAccentColor()"
        [webchatAccentTextColor]="webchatAccentTextColor()"
        [placeholder]="'WEBCHAT.WIDGET.INPUT_MESSAGE' | translate"
        [showFooterContent]="showFooterContent()"
        [poweredBy]="poweredBy()"
        [processing]="isCreatingConversation()"
        [canClose]="canClose()"
        [preventScrollOnFocus]="true"
        [hideComposer]="hideComposer()"
        [parentHostname]="configSvc.hostPageHostname()"
      >
      </webchat-box>
    }
  </div>
  @if (!embedded() && !(isNarrowViewport() && showWebchat() && fullView())) {
    <webchat-button
      (clicked)="toggleChat()"
      [hideStatus]="!!showWebchat()"
      [position]="position()"
      [backgroundColor]="webchatColor()"
      [iconColor]="webchatTextColor() === 'light' ? 'light' : 'dark'"
    ></webchat-button>
  }
}
